import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../../../routes/Routes';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';
import { EmailTemplate } from '../../../types/EmailTemplate';
import { mutationKeys } from '../mutationKeys';

export const postEmailTemplate = async (formData: EmailTemplate) => {
  const response = await CustomAxios.post(`email_templates`, formData);
  const { data } = response;
  return data;
};

type useCreateEmailTemplateProps = {
  onSuccessCallback: () => void;
};

export function useCreateEmailTemplate({ onSuccessCallback }: useCreateEmailTemplateProps) {
  const navigate = useNavigate();
  return useMutation({
    mutationKey: [mutationKeys.createEmailTemplate],
    mutationFn: (formData: EmailTemplate) => postEmailTemplate(formData),
    onSuccess: (data: EmailTemplate) => {
      // fetch again after create
      queryClient.invalidateQueries({ queryKey: [queryKeys.allEmailTemplates, 'new'] });

      // call success
      onSuccessCallback();

      navigate(`/${ROUTE_PATHS.EMAIL_TEMPLATES}/${data.uuid}`);
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        // let set the query data with bad errored response
        const emailTemplate: EmailTemplate = err.response.data as EmailTemplate;
        queryClient.setQueryData([queryKeys.allEmailTemplates, 'new'], emailTemplate);
      }
    },
  });
}
